import React from 'react'
import SectionBlock from './template/SectionBlock'

export default function Footer() {
    return (
        <footer className='text-sm text-secondary px-4  py-6 sm:p-6 w-full  font-semibold'>
            <div className='container mx-auto flex justify-center sm:justify-between flex-wrap gap-3 '>
            <p>&copy; 2026 Tuhin Kairi</p>
            <p>Designed and Developed by Tuhin Kairi</p>
            </div>
        </footer>
    )
}
